import BackupAllItemPolicy from './BackupAllItemPolicy';
import BooleanMapForm from './types/BooleanMap';
import { DEFAULT_POLICIES_TYPES } from './constants';
import DataCenterForm from './types/DataCenter';
import ExcludeSitesForm from './types/ExcludeSites';
import ListForm from './types/List';
import MasterPasswordForm from './types/MasterPassword';
import Policy from './Policy';
import React from 'react';
import TypeForm from './types/Type';

export function findPolicyType(type, context) {
    if (POLICIES_TYPES[type]) {
        return POLICIES_TYPES[type](context);
    }
    return DEFAULT_POLICY(context);
}

const DEFAULT_POLICY = ({ index, policy, onChange, editable }) => {
    console.warn(`Not found policy: ${policy.policy.lookup}`);
    return (
        <Policy
            key={index}
            policy={policy}
            onPolicyEnableChange={onChange}
            editable={editable}
        />
    );
};

const POLICIES_TYPES = {
    boolean: ({ index, policy, editable, onChange }) => (
        <Policy
            key={index}
            policy={policy}
            onPolicyEnableChange={onChange}
            editable={editable}
        />
    ),
    backup: ({ index, policy, editable, onChange, pb6Enabled }) => (
        <BackupAllItemPolicy
            key={index}
            policy={policy}
            onPolicyEnableChange={onChange}
            editable={editable}
            pb6Enabled={pb6Enabled}
        />
    ),
    type: ({ index, policy, onChange, types, editable }) => {
        const targetTypes =
            types || DEFAULT_POLICIES_TYPES[policy.policy.identifier];
        return (
            <Policy
                key={index}
                policy={policy}
                onPolicyEnableChange={onChange}
                renderEnableDescription={policy => {
                    const type = targetTypes.find(
                        s => s.code === policy.value.policy
                    );
                    return type && type.name;
                }}
                renderForm={(policy, enabled) => {
                    return (
                        <TypeForm
                            enabled={enabled}
                            policy={policy}
                            types={targetTypes}
                            onSave={onChange}
                            editable={editable}
                        />
                    );
                }}
                editable={editable}
            />
        );
    },
    list: ({ index, policy, onChange, editable }) => (
        <Policy
            key={index}
            policy={policy}
            onPolicyEnableChange={onChange}
            renderEnableDescription={policy =>
                policy.value.policy.split(',').join(', ')
            }
            renderForm={(policy, enabled) => (
                <ListForm
                    enabled={enabled}
                    policy={policy}
                    onSave={onChange}
                    editable={editable}
                />
            )}
            editable={editable}
        />
    ),
    'data-center': ({ index, policy, onChange, storageRegion, editable }) => (
        <Policy
            key={index}
            policy={policy}
            onPolicyEnableChange={onChange}
            renderEnableDescription={policy => {
                const region = storageRegion.find(
                    s => s.code === policy.value.policy
                );
                return region && region.name;
            }}
            renderForm={(policy, enabled) => {
                return (
                    <DataCenterForm
                        enabled={enabled}
                        policy={policy}
                        storageRegion={storageRegion}
                        onSave={onChange}
                        editable={editable}
                    />
                );
            }}
            editable={editable}
        />
    ),
    password: ({ index, policy, onChange, storageRegion, editable }) => (
        <Policy
            key={index}
            policy={policy}
            onPolicyEnableChange={onChange}
            renderEnableDescription={policy => {
                const [days, passwd] = policy.value.policy.split(',');
                return `${days} days, ${passwd} passwords`;
            }}
            renderForm={(policy, enabled) => {
                return (
                    <MasterPasswordForm
                        enabled={enabled}
                        policy={policy}
                        storageRegion={storageRegion}
                        onSave={onChange}
                        editable={editable}
                    />
                );
            }}
            editable={editable}
        />
    ),
    'exclude-sites': ({ index, policy, onChange, editable }) => (
        <Policy
            key={index}
            policy={policy}
            onPolicyEnableChange={onChange}
            renderEnableDescription={policy =>
                policy.value.policy.map(item => item.uri).join(', ')
            }
            renderForm={(policy, enabled) => {
                return (
                    <ExcludeSitesForm
                        enabled={enabled}
                        policy={policy}
                        onSave={onChange}
                        editable={editable}
                    />
                );
            }}
            editable={editable}
        />
    ),
    'list-boolean': ({ index, policy, onChange, editable }) => (
        <Policy
            key={index}
            policy={policy}
            onPolicyEnableChange={onChange}
            renderEnableDescription={policy => {
                const policies = Object.entries(policy.value.policy || {});
                return policies
                    .map(([name, value]) => `${name}: ${value ? 'Yes' : 'No'}`)
                    .join(', ');
            }}
            renderForm={(policy, enabled) => (
                <BooleanMapForm
                    enabled={enabled}
                    policy={policy}
                    onSave={onChange}
                    editable={editable}
                />
            )}
            editable={editable}
        />
    ),
};
